import { ServiceNodeDetail } from '@bumble/app/__generated__/data-contracts';
import { Indicator } from '@bumble/app/components/Indicator';
import { Loading } from '@bumble/app/components/Loading';
import NoData from '@bumble/app/components/NoData';
import { TabGrid, TabGridStructure } from '@bumble/app/components/TabGrid';
import getDate from '@bumble/app/utils/get-date';

export const ServiceNodeTabDetails = ({
  data,
  loading,
}: {
  data: ServiceNodeDetail | undefined;
  loading: boolean;
}) => {
  if (loading) return <Loading />;
  if (data === undefined) return <NoData />;
  const tabData: TabGridStructure[] = [
    {
      label: 'Service Node Name',
      content: data?.service_node_name || 'N/A',
    },
    {
      label: 'Service Node Id',
      content: data?.service_node_id || 'N/A',
    },
    {
      label: 'Service Node Group Id',
      content: data?.service_node_group_id || 'N/A',
    },
    {
      label: 'Created at',
      content: data !== undefined && data?.created_at ? getDate(data?.created_at) : 'N/A',
    },
    {
      label: 'Description',
      content: data?.description || 'N/A',
    },
    {
      label: 'Admin State',
      content: data?.admin_state || 'N/A',
    },
    {
      label: 'Admin State Change at',
      content:
        data !== undefined && data?.admin_state_change_at
          ? getDate(data?.admin_state_change_at)
          : 'N/A',
    },
    {
      label: 'OP State',
      content: data?.op_state !== undefined ? <Indicator active={data?.op_state === 'up'} /> : 'N/A',
    },
    {
      label: 'OP State Change at',
      content:
        data !== undefined && data?.op_state_change_at ? getDate(data?.op_state_change_at) : 'N/A',
    },
    {
      label: 'Account Id',
      content: data?.account_id || 'N/A',
    },
    //    {
    //      label: 'Public IP',
    //      content: data?.public_ip || 'N/A',
    //    },
    {
      label: 'Private IP',
      content: data?.private_ip || 'N/A',
    },
    {
      label: 'Form Factor',
      content: data?.form_factor || 'N/A',
    },
    {
      label: 'Shipping Addr',
      content: data?.shipping_addr || 'N/A',
    },
  ];
  return <TabGrid data={tabData} />;
};
